import { Selection } from "../type";
/** i18n関係の関数をまとめるモジュール */

// based on : https://stackoverflow.com/questions/51984243/checking-if-a-value-is-valid-for-a-union-type
/** for runtime validation, use LANGUAGE_VALUES array */
export const LANGUAGE_VALUES = [
  "ja",
  "en",
  "ko",
  "zh_CN",
  "zh_TW",
  "vi",
  "id",
  "th",
] as const; // ISO 639-1 2 letter language code

/** for static type assertion, use Languages type */
export type Languages = (typeof LANGUAGE_VALUES)[number];
export const DEFAULT_LANGUAGE: Languages = "ja";

export const LANGUAGE_LABELS: { [key in Languages]: string } = {
  ja: "日本語",
  en: "English",
  ko: "한국어",
  zh_CN: "简体中文",
  zh_TW: "繁體中文",
  vi: "Tiếng Việt",
  id: "Bahasa Indonesia",
  th: "ภาษาไทย",
};

export const MAP_SUPPORTED_LANGUAGES: { [key in Languages]?: string } = {
  ja: "ja",
  en: "en",
  ko: "ko",
  zh_CN: "zh-Hans",
  zh_TW: "zh-Hant",
  vi: "vi",
  id: "id",
  th: "th",
};

/** meta.languagesに指定された言語でフィルタしたLANGUAGE_LABELSを返す。 */
export function filterLanguagesByMetaLanguages(languages: Selection[]): {
  [key in Languages]?: string;
} {
  const result: { [key in Languages]?: string } = {};
  for (const lang of languages) {
    if (LANGUAGE_VALUES.includes(lang.key as Languages)) {
      result[lang.key as Languages] = LANGUAGE_LABELS[lang.key as Languages];
    }
  }
  return result;
}
